import { defineStore } from 'pinia';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSetupPasswordStore = defineStore({
    id: 'setupPassword',
    state: () => ({}),
    getters: {},
    actions: {
        /**
         * ログイン直後のパスワード更新処理。
         * @param {String} oldPassword
         * @param {String} newPassword
         * @returns response
         */
        async cognitoUpadatePasswordByFirstLoginAction(oldPassword, newPassword) {
            try {
                const response = await cognitoRepository.changeCognitoPasswordByAfterLogin(oldPassword, newPassword);
                return response;
            } catch (e) {
                return e;
            }
        },
    },
});
